const features = [
  {
    name: 'backdropfilter',
    check: () => {
      const modern = window.CSS && window.CSS.supports;
      return modern && (
        window.CSS.supports('backdrop-filter', 'blur(1px)') ||
        window.CSS.supports('-webkit-backdrop-filter', 'blur(1px)')
      );
    },
  },
  {
    name: 'iossafari',
    check: () => {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
      return iOSSafari;
    },
  },
];

class FeatureDetect {
  constructor() {
    this.started = false;
  }

  start(elem) {
    if (!this.started) {
      this.started = true;
      this.elem = elem;
      this.check();
    }
  }

  check() {
    features.forEach((f) => {
      const can = f.check();
      if (can) {
        this.elem.classList.add(`tsil-feature-${f.name}`);
      } else {
        this.elem.classList.add(`tsil-feature-not-${f.name}`);
      }
    });
  }
}

export default new FeatureDetect();
